import React, { useState } from 'react';
import NavigationMobileDropdown from '@/features/PortalNavigation/variants/mobile/NavigationCollapse/NavigationCollapse';
import NavigationButton from '@/features/PortalNavigation/variants/dropdown/NavigationButton/NavigationButton';
import { PortalNavigationProps } from '@/features/PortalNavigation/PortalNavigation.interfaces';
import { useMobilePortalNavigationStyles } from '@/features/PortalNavigation/variants/mobile/MobilePortalNavigation/MobilePortalNavigation.styles';

export const MobilePortalNavigation = ({
  label,
  'data-datalayer-position': datalayerPosition,
  'data-datalayer-variant': datalayerVariant,
  navigationItems,
}: PortalNavigationProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const classes = useMobilePortalNavigationStyles();

  return (
    <>
      <div className={classes.backButtonContainer}>
        <NavigationButton
          id="portal-navigation"
          onClick={() => setIsOpen((prev) => !prev)}
          isOpened={isOpen}
        >
          {label}
        </NavigationButton>
      </div>
      <NavigationMobileDropdown
        navigationItems={navigationItems}
        isOpen={isOpen}
        onNavigationItemClick={() => setIsOpen(false)}
        data-datalayer-position={datalayerPosition}
        data-datalayer-variant={datalayerVariant}
      />
    </>
  );
};
